import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import {
  CHAT_GROUP_BY_COMPONENT,
  CHAT_GROUP_BY_ID,
  GLOBAL_STATE,
  MESSAGES_GROUP,
  MESSAGES_GROUP_ALL,
} from '../constants/actionTypes'
import * as actionCreators from './actions'
import { defaultState, initialState } from './initialState'

export const ChAT_GROUP_MESSAGE = GLOBAL_STATE

export const { reducer: chatGroupReducer } = createSlice({
  name: ChAT_GROUP_MESSAGE,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(actionCreators.chatGroupByComponent.pending, state => {
        state[CHAT_GROUP_BY_COMPONENT].loading = true
      })
      .addCase(actionCreators.chatGroupByComponent.rejected, (state, action) => {
        state[CHAT_GROUP_BY_COMPONENT].loading = false
        state[CHAT_GROUP_BY_COMPONENT].error = action.payload as AxiosError
      })
      .addCase(actionCreators.chatGroupByComponent.fulfilled, (state, action) => {
        state[CHAT_GROUP_BY_COMPONENT].loading = false
        state[CHAT_GROUP_BY_COMPONENT].error = null
        state[CHAT_GROUP_BY_COMPONENT].data = action.payload
      })

    builder.addCase(actionCreators.chatGroupByComponentClear, state => {
      state[CHAT_GROUP_BY_COMPONENT] = defaultState()
    })

    builder
      .addCase(actionCreators.chatGroupById.pending, state => {
        state[CHAT_GROUP_BY_ID].loading = true
      })
      .addCase(actionCreators.chatGroupById.rejected, (state, action) => {
        state[CHAT_GROUP_BY_ID].loading = false
        state[CHAT_GROUP_BY_ID].error = action.payload as AxiosError
      })
      .addCase(actionCreators.chatGroupById.fulfilled, (state, action) => {
        state[CHAT_GROUP_BY_ID].loading = false
        state[CHAT_GROUP_BY_ID].error = null
        state[CHAT_GROUP_BY_ID].data = action.payload
      })

    builder.addCase(actionCreators.chatGroupByIdClear, state => {
      state[CHAT_GROUP_BY_ID] = defaultState()
    })

    builder
      .addCase(actionCreators.messagesGroup.pending, state => {
        state[MESSAGES_GROUP].loading = true
      })
      .addCase(actionCreators.messagesGroup.rejected, (state, action) => {
        state[MESSAGES_GROUP].loading = false
        state[MESSAGES_GROUP].error = action.payload as AxiosError
      })
      .addCase(actionCreators.messagesGroup.fulfilled, (state, action) => {
        state[MESSAGES_GROUP].loading = false
        state[MESSAGES_GROUP].error = null
        state[MESSAGES_GROUP].data = action.payload
      })

    builder
      .addCase(actionCreators.messagesGroupAll.pending, state => {
        state[MESSAGES_GROUP_ALL].loading = true
      })
      .addCase(actionCreators.messagesGroupAll.rejected, (state, action) => {
        state[MESSAGES_GROUP_ALL].loading = false
        state[MESSAGES_GROUP_ALL].error = action.payload as AxiosError
      })
      .addCase(actionCreators.messagesGroupAll.fulfilled, (state, action) => {
        state[MESSAGES_GROUP_ALL].loading = false
        state[MESSAGES_GROUP_ALL].error = null
        state[MESSAGES_GROUP_ALL].data = action.payload
      })

    builder.addCase(actionCreators.messagesGroupClear, state => {
      state[MESSAGES_GROUP] = defaultState()
    })

    builder.addCase(actionCreators.messagesGroupAllClear, state => {
      state[MESSAGES_GROUP_ALL] = defaultState()
    })
  },
})
